<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15K7r6j/tc-custom/9781250230430.jpg?1730635608704" alt="This image is the cover for the book 24"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">24
      </h1>
      <p class="bookDescription body article font2">
        <b>The uplifting <i>New York Times</i> bestseller by the legendary Willie Mays: “Will remind fans of why we love baseball so much.” —<i>The New York Times</i></b><br/><br/>In this “mix of memoir, self-help, and baseball history” (Booklist), Willie Mays shares the inspirations and influences responsible for guiding him on and off the field. Widely regarded as the greatest all-around player in history because of his unparalleled hitting, defense, and baserunning, the beloved Hall of Famer recounts his lifetime of experience meeting challenges with positivity, integrity, and triumph. Presented in 24 chapters to correspond with his universally recognized uniform number, Willie’s memoir provides more than the story of his major-league career. It tells of a man who values family and community, engages in charitable causes—especially those that help children—and follows a philosophy that encourages hope, hard work, and the pursuit of dreams.<br/><br/>“Baseball fans of all ages and anyone seeking inspiration will enjoy memories and motivation shared in a warm, joyous manner by the irrepressible Say Hey Kid.”—<i>Library Journal</i> (starred review)<br/><br/>“A salute to what the game used to be . . . back when it was a game played for the love of it, by guys who still lived in the neighborhood.” —<i>New York Daily News</i><br/><br/><i>Includes photos and a foreword by Bob Costas</i><br/><br/>“I was very lucky when I was a child. My family took care of me and made sure I was in early at night. I didn’t get in trouble. My father made sure that I didn’t do the wrong thing. I’ve always had a special place in my heart for children and their well-being, and John Shea and I got the idea that we should do something for the kids and the fathers and the mothers, and that’s why this book is being published. We want to reach out to all generations and backgrounds. Hopefully, these stories and lessons will inspire people in a positive way.” —Willie Mays<br/><br/>“It’s because of giants like Willie that someone like me could even think about running for president.” —Barack Obama
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Willie Mays, John Shea
      </h2>
      
      <p class="authorDescription body article"><P>WILLIE MAYS, forever the youthful Say Hey Kid, was a major-league center fielder for 22 seasons with the New York Giants, San Francisco Giants and New York Mets and played for the Birmingham Black Barons in the Negro Leagues. He hit 660 home runs, collected 3,283 hits, stole 338 bases, earned 12 Gold Gloves and played in 24 All-Star Games. He was inducted into the Baseball Hall of Fame in 1979.<br><br>JOHN SHEA is the award-winning national baseball columnist at the San Francisco Chronicle and Willie's longtime acquaintance. He has written several books, including the autobiography of Hall of Famer Rickey Henderson, <I>Off Base: Confessions of a Thief.</I> He is seen regularly on MLB Network.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?9329cf4a